import React, { Component } from "react";
import {
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Divider,
    Typography,
    IconButton,
    Collapse,
    AppBar,
    Toolbar,
    Box,
    Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Grid,
    Button
} from "@mui/material";
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline';
import EditIcon from '@mui/icons-material/Edit';
import GroupRemoveIcon from '@mui/icons-material/GroupRemove';
import {
    Dashboard as DashboardIcon,
    AccountCircle as AccountCircleIcon,
    Assessment as ReportIcon,
    WorkOutline as WorkOutlineIcon,
    Security as RolesMasterIcon,
    Work as JobIcon,
    MenuOpen as MenuOpenIcon,
    ListAlt as ListAltIcon,
    CloudUpload as JobUploadIcon,
    ExpandLess,
    ExpandMore,
    ChevronLeft as CollapseIcon,
    ChevronRight as ExpandIcon,
    Brightness4 as DarkModeIcon,
    Brightness7 as LightModeIcon,
    MoreHoriz as MoreHorizIcon,
    Reply as ReplyIcon,
    Logout as LogoutIcon,
    RoomPreferences as RoomPreferencesIcon,
    CoPresent as CoPresentIcon,
    Publish as PublishIcon,
    Engineering as EngineeringIcon,
    Settings as SettingsIcon,
    AddLink as LinkIcon,
    Apps,
    ScheduleSend
} from "@mui/icons-material";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { SidebarContainer } from "./SidebarStyles";
import { NavigateFunction } from "react-router-dom";
import { Avatar, Menu, MenuItem } from '@mui/material';
import { logout, authContext } from '../../LoginConfig/AdalConfig';
import { decodeJwt, rolenum, sidebarGridUrl, UserRole } from "../Pages/ApiCommonService";
import BrokerQCRefrenceMapping from "../Pages/BrokerQCRefrenceMapping";
import { fetchBrokerLogoById } from '../ApiSevices/ExdionAdminApi';
import { withNavigation } from "../Common/withNavigation";
import AssignmentIcon from '@mui/icons-material/Assignment';
import AutoAwesomeMosaicIcon from '@mui/icons-material/AutoAwesomeMosaic';

const drawerWidth = 230;
const collapsedWidth = 60;

interface SidebarState {
    darkMode: boolean;
    usersOpen: boolean;
    jobsOpen: boolean;
    reportOpen: boolean;
    anchor: null | HTMLElement;
    sidebarExpanded: boolean;
    authUser: any
    activeItem: string | null;
    activeSubItem: number | null;
    roleId: any;
    user: any;
    logoPreview: any;
    showProfileModal: boolean;
    activeApplicationPath: string;
    basePath: string;
}
interface SidebarProps {
    displaysidebar: boolean;
    toggleSidebar: () => void;
    assignedMenus: any;
    allowedMenus: any;
    logoForBroker: string | null;
    navigate: NavigateFunction;
    basePath: string;
}

class Sidebarr extends Component<SidebarProps, SidebarState> {
    constructor(props: SidebarProps) {
        super(props);
        this.state = {
            darkMode: false,
            usersOpen: false,
            anchor: null,
            jobsOpen: false,
            reportOpen: false,
            sidebarExpanded: true,
            authUser: authContext.getCachedUser() || null,
            activeItem: window.location.pathname === '/' ? '/home/dashboard' : window.location.pathname,
            activeSubItem: null,
            roleId: '',
            logoPreview: null,
            user: "",
            showProfileModal: false,
            activeApplicationPath: "",
            basePath: ""
        };
    }

    getBrokerLogoName = () => {
        try {
            const token = sessionStorage.getItem("token");
            if (!token) return "exdionlogo";
            const decoded = decodeJwt(token);
            const brokerId = decoded?.BrokerId;

            return brokerId ? `${Number(brokerId)}` : "exdionlogo";
        } catch (err) {
            console.error("Error extracting BrokerId from session token", err);
            return "exdionlogo";
        }
    };

    componentDidMount() {
        const currentPath = window.location.pathname + window.location.search;
        const token = sessionStorage.getItem('token');

        const { basePath } = this.props;

        let path = "";

        if (basePath.startsWith("/policyCheck/")) {
            path = window.location.pathname.replace(
                `${basePath}/`,
                ""
            );

            path = `/${path}`;
        }
        else {
            path = window.location.pathname.replace(
                `${basePath}/`,
                ""
            );

            path = `/${path}`;
        }

        this.setState({
            activeItem: path,
            basePath,
            activeApplicationPath: basePath
        });
        if (token) {
            const decodedToken = decodeJwt(token);
            if (decodedToken) {
                this.setState({
                    roleId: parseInt(decodedToken?.RoleId), user: decodedToken?.Email, authUser: {
                        ...decodedToken,
                        brokerId: decodedToken?.BrokerId,
                        roleId: decodedToken?.RoleId,
                        userName: decodedToken?.userName || decodedToken?.Email
                    }
                });
            } else {
                console.warn("Token decoding failed or returned null");
            }
        }

        this.setState({
            usersOpen: currentPath.startsWith('/users'),
            jobsOpen: currentPath.startsWith('/jobs'),
        });
    }

    handleBrokerLogo = async (brokerId: any) => {
        try {
            const logoForBroker = await fetchBrokerLogoById(brokerId);
            const firstLogo = Array.isArray(logoForBroker) ? logoForBroker[0] : logoForBroker;
            this.setState({
                logoPreview: firstLogo?.BaseString || null
            });
        } catch (error) {
            console.error('Error fetching data for brokerid:', error);
        }
    };

    toggleTheme = () => {
        this.setState((prevState) => ({ darkMode: !prevState.darkMode }));
    };

    toggleDashboard = () => {
        this.setState({
            reportOpen: false,
            jobsOpen: false
        });
    };

    toggleUser = () => {
        this.setState((prevState) => ({
            usersOpen: !prevState.usersOpen, reportOpen: false,
            jobsOpen: false
        }));
    };

    toggleJobs = () => {
        this.setState((prevState) => ({
            jobsOpen: !prevState.jobsOpen, usersOpen: false,
            reportOpen: false
        }));
    };

    toggleReport = () => {
        this.setState((prevState) => ({
            reportOpen: !prevState.reportOpen, usersOpen: false,
            jobsOpen: false
        }));
    };

    handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        this.setState({ anchor: event.currentTarget });
    };

    handleMenuClose = () => {
        this.setState({ anchor: null });
    };

    handleItemClick = (id: string) => {
        const { navigate } = this.props;
        const { activeApplicationPath } = this.state;
        this.setState({
            activeItem: id,
            activeSubItem: null,
            reportOpen: false,
            jobsOpen: false
        });
        if (id === "/") {
            this.props.navigate("/", { replace: true });
            return
        }
        navigate(activeApplicationPath + id, { relative: "path" });
    };

    handleSubItemClick = (subItemId: number, needRefresh: boolean = false) => {
        this.setState({ activeSubItem: subItemId });
    };

    handleSignOut = () => {
        this.handleMenuClose();
        logout();
    };

    handleProfileModalOpen = () => {
        this.setState({ showProfileModal: true, anchor: null });
    };

    handleProfileModalClose = () => {
        this.setState({ showProfileModal: false });
    };


    render() {
        const { darkMode, user, jobsOpen, reportOpen, anchor, authUser, activeItem, activeSubItem, roleId, logoPreview } = this.state;
        const User = authUser?.userName || authUser?.email;
        const usernameMap = User?.split('@')[0] || "Guest";
        const userName = usernameMap?.charAt(0)?.toUpperCase() + usernameMap?.slice(1);
        const currentPath = window.location.pathname;
        const basePath = window.location.pathname.split('/')[1];
        const isMenuControlFlag = window.location.pathname.split('/')[2] === 'commercialLine';

        const { displaysidebar, toggleSidebar, assignedMenus, allowedMenus, logoForBroker } = this.props
        const theme = createTheme({
            palette: {
                mode: darkMode ? "dark" : "light",
            },
        });
        // const isShowDashboardFlag = roleId !== UserRole.ExdionAdmin && roleId !== UserRole.BrokerAdmin && roleId !== UserRole.CSR
        //     && roleId !== UserRole.QA && roleId !== UserRole.Supervisor && roleId !== UserRole.Reviewer && roleId != UserRole.MSUser;

        const userRoleData = JSON.parse(sessionStorage.getItem('UserRole') || '{}');
        const isShowDashboardFlag = roleId && [UserRole.QA, UserRole.Reviewer].includes(roleId) && userRoleData?.data?.Role && userRoleData?.data?.Role?.includes("report");

        let sidebarMenuMap: any = {
            "Dashboard": { path: "/home/dashboard", label: "Dashboard", icon: <DashboardIcon /> },
            "CsrDashboard": { path: "/home/csrdashboard", label: "View Dashboard", icon: <DashboardIcon /> },
            "Introducebroker": { path: "/introducebroker/*", label: "IntroduceBroker", icon: <CoPresentIcon /> },
            "Joblisting": { path: "/jobs/joblisting?statusId=0", label: "Job Listing", icon: <WorkOutlineIcon />, parent: "Jobs" },
            "JobCsrListing": { path: "/jobs/jobcsrlisting?statusId=0", label: "Csr Listing", icon: <WorkOutlineIcon />, parent: "Jobs" },
            "JobMaintenance": { path: "/jobs/jobMaintenance", label: "Job Maintenance", icon: <WorkOutlineIcon />, parent: "Jobs" },
            "Upload": { path: "/jobs/upload", label: "Upload Documents", icon: <WorkOutlineIcon />, parent: "Jobs" },
            "ReUpload": { path: "/jobs/reupload", label: "File ReUpload", icon: <WorkOutlineIcon />, parent: "Jobs" },
            "CSRUpload": { path: "/InterUpload", label: "CSR Upload", icon: <PublishIcon /> },
            "UserMaster": { path: "/usermaster", label: "User Master", icon: <AccountCircleIcon /> },
            "Productionreport": { path: "/misreport/productionreport", label: "Production Report", icon: <ReportIcon />, parent: "MIS Report" },
            "FileUploadDetailsReport": { path: "/misreport/fileuploaddetailsreport", label: "File Upload Details Report", icon: <ReportIcon />, parent: "MIS Report" },
            "OverallStatusReport": { path: "/misreport/overallstatusreport", label: "Overall Status Report", icon: <ReportIcon />, parent: "MIS Report" },
            "AutoJoblobmappingreport": { path: "/misreport/autojoblobmappingreport", label: "Auto Job LOB Mapping Report", icon: <ReportIcon />, parent: "MIS Report" },
            "Acordjsondata": { path: "/misreport/acordjsondata", label: "Acord Json Data", icon: <ReportIcon />, parent: "MIS Report" },
            "Pivottablereport": { path: "/misreport/pivottablereport", label: "Pivot Table Report", icon: <ReportIcon />, parent: "MIS Report" },
            "Checklisterrorlog": { path: "/misreport/checklisterrorlog", label: "CheckList Error Log", icon: <ReportIcon />, parent: "MIS Report" },
            ...(isMenuControlFlag && { "MenuControl": { path: "/home/MenuControl", label: "MenuControl", icon: <EngineeringIcon /> } }),
            "AutoDispatcher": { path: "/home/AutoDispatcher", label: "AutoDispatcher", icon: <ScheduleSend /> },
            "QuestionConfig": { path: "/home/questionConfig", label: "QuestionConfig", icon: <ListAltIcon /> },
            "SemanticConfig": { path: "/home/semanticConfig", label: "SemanticConfig", icon: <ListAltIcon /> },
            "UploadChecklistTemp": { path: "/UploadChecklistTemp", label: "Checklist Template", icon: <ViewTimelineIcon /> },
            "ValidationSecurity": { path: "/validation_security", label: "Validation & Security", icon: <RoomPreferencesIcon /> },
            "QuestionManagement": { path: "/home/questionConfigReference", label: "QuestionReferenceMapping", icon: <SettingsIcon /> },
            "GenerateAmsURL": { path: "/home/GenerateAMSUrl", label: "Generate AMS URL", icon: <LinkIcon /> },
            "MyApps": { path: "/", label: "My Apps", icon: <Apps /> },
            "StpMaster": { path: "/home/stpMaster", label: "STP Master", icon: <WorkOutlineIcon /> },
            "QcConfig": { path: "/home/QcConfig", label: "QcConfig", icon: <WorkOutlineIcon /> },
            "PrimarySecondaryUserConfig": { path: "/home/PrimarySecondaryUserConfig", label: "Primary&SecondaryUserConfig", icon: <GroupRemoveIcon /> },
            "LobSplitQuestionMaster": { path: "/home/lobsplitquestionMaster", label: "LobSplitQuestionMaster", icon: <AssignmentIcon /> },
            "LobSplitConfig": { path: "/home/LobSplitConfig", label: "LobSplitConfig", icon: <SettingsIcon /> },
            "UserAccess": { path: "/home/UserAccess", label: "User Access Management", icon: <GroupRemoveIcon /> },
            ...(isMenuControlFlag && { "ComplianceScreen": { path: "/home/ComplianceScreen", label: "ComplianceScreen", icon: <AutoAwesomeMosaicIcon /> } }),
        };
        if (basePath === 'quote') {
            sidebarMenuMap = {
                ...sidebarMenuMap,
                "QuoteDashboard": { path: "/home/dashboard", label: "Dashboard", icon: <DashboardIcon /> },
                "QuoteQuestionConfig": { path: "/home/QcQuestionConfig", label: "Question Config", icon: <SettingsIcon /> },
                "QuoteJobListing": { path: "/jobs/joblisting?statusId=0", label: "Job Listing", icon: <WorkOutlineIcon />, parent: "Jobs" },
                "QuoteJobCsrListing": { path: "/jobs/jobcsrlisting?statusId=0", label: "Csr Listing", icon: <WorkOutlineIcon />, parent: "Jobs" },
                "QuoteProductionreport": { path: "/misreport/productionreport", label: "Production Report", icon: <ReportIcon />, parent: "MIS Report" },
                "QuoteFileUploadDetailsReport": { path: "/misreport/fileuploaddetailsreport", label: "File Upload Details Report", icon: <ReportIcon />, parent: "MIS Report" },
                "QuoteOverallStatusReport": { path: "/misreport/overallstatusreport", label: "Overall Status Report", icon: <ReportIcon />, parent: "MIS Report" },
                "QuoteUpload": { path: "/jobs/upload", label: "Upload Documents", icon: <WorkOutlineIcon />, parent: "Jobs" },
                "QuoteUserAccess": { path: "/home/QcUserAccess", label: "User Access Management", icon: <GroupRemoveIcon /> }
            };
        }
        console.log("assignedMenus", assignedMenus);
        console.log("menus", assignedMenus?.menus);
        console.log(
            "Contains QuoteUserAccess?",
            assignedMenus?.menus?.includes("QuoteUserAccess")
        );
        const menus = assignedMenus?.menus || []; // fallback to empty array

        const misReportMenus = menus?.filter(
            (menu: string) => sidebarMenuMap[menu]?.parent === "MIS Report"
        );

        const desiredJobsOrder = ["Joblisting", "JobCsrListing", "JobMaintenance", "Upload", "ReUpload", "QuoteJobCsrListing", "QuoteJobListing", "QuoteUpload"];
        const jobsMenus = desiredJobsOrder?.filter(
            (key) => menus?.includes(key) && sidebarMenuMap[key]?.parent === "Jobs"
        );

        const lowerUser = (User || "").toLowerCase();
        let topLevelMenus = menus?.filter((menu: string) => {
            if (["QuestionConfig", "QuestionManagement"].includes(menu)) {
                const allowedMenuEntry = allowedMenus?.find((m: any) => m.Menu === menu);
                const allowedUsers = allowedMenuEntry?.UserId?.toLowerCase()?.split(',') || [];

                if (!allowedUsers.includes(lowerUser)) {
                    return false;
                }
            }

            return !sidebarMenuMap[menu]?.parent
        });
        topLevelMenus = ["MyApps", ...topLevelMenus.filter((menu: any) => {
            if (menu === "UserMaster" && basePath !== "userManagement") {
                return false;
            }
            return true;
        })];

        return (
            <SidebarContainer displaysidebar={displaysidebar}>
                <AppBar
                    position="fixed"
                    elevation={0}
                    sx={{
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        backgroundColor: theme.palette.background.default,
                        borderBottom: "1px solid #ddd",
                    }}
                >
                    <Toolbar>
                        {!["/"].includes(window.location.pathname) &&
                            <Tooltip title={displaysidebar ? "Collapse Menu" : "Expand Menu"}>
                                <IconButton onClick={toggleSidebar} edge="start" style={{ padding: '1px', border: '1.5px solid gainsboro', borderRadius: '20px' }}>
                                    {displaysidebar ? <MenuOpenIcon /> : <MenuOpenIcon />}
                                </IconButton>
                            </Tooltip>
                        }

                        {/* <Box sx={{ display: "flex", alignItems: "center", position: 'relative', top: '2px', marginLeft: '12px' }}>
                            <img
                                src={logoForBroker
                                    ? `data:image/png;base64,${logoForBroker}` : `/logos/${this.getBrokerLogoName()}.png`}
                                alt="broker-logo"
                                onError={(e) => {
                                    const target = e.target as HTMLImageElement;
                                    target.onerror = null;
                                    target.src = "/exdionedge.jpg";
                                }}
                                className="logo-img"
                            />
                        </Box> */}

                        <Typography variant="h6" sx={{ position: 'relative', left: '70px', color: 'black', flexGrow: 1, margin: '10px', textAlign: "center", fontWeight: 'bold' }}>
                            Welcome to Exdion
                        </Typography>

                        {/* Profile Icon & Menu */}
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Avatar
                                alt="Profile"
                                src="/profile.png"
                                sx={{ cursor: "pointer" }}
                                onClick={this.handleMenuOpen}
                            >
                                {usernameMap.charAt(0).toUpperCase()}
                            </Avatar>&nbsp;&nbsp;<span
                                style={{ color: 'black', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer' }}
                                onClick={this.handleMenuOpen}
                            >
                                {userName} <KeyboardArrowDownIcon sx={{ fontSize: "10px" }} />
                            </span>
                            <Menu
                                anchorEl={anchor}
                                open={Boolean(anchor)}
                                onClose={this.handleMenuClose}
                                PaperProps={{
                                    style: {
                                        borderRadius: 10,
                                        boxShadow: '0px 4px 16px rgba(0,0,0,0.1)',
                                        minWidth: 200
                                    }
                                }}
                            >
                                <MenuItem onClick={this.handleProfileModalOpen}>
                                    <PersonOutlineIcon sx={{ marginRight: '8px' }} />
                                    Profile info
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={this.handleSignOut} sx={{ color: 'red' }}>
                                    <LogoutIcon sx={{ marginRight: '8px', color: 'red' }} />
                                    Sign Out
                                </MenuItem>
                            </Menu>
                        </Box>
                    </Toolbar>
                </AppBar>

                {/* Sidebar */}
                <Drawer
                    variant="permanent"
                    sx={{
                        width: displaysidebar ? drawerWidth : collapsedWidth,
                        flexShrink: 0,
                        [`& .MuiDrawer-paper`]: {
                            width: displaysidebar ? drawerWidth : collapsedWidth,
                            height: '100vh', // Make sure Drawer paper fills full height
                            display: 'flex',
                            flexDirection: 'column',
                            overflow: 'hidden', // Prevent scrollbar on Drawer itself
                        },
                    }}
                >
                    <Box
                        sx={{
                            flex: 1,                 // Take full height of Drawer
                            overflowY: 'auto',      // Enable scroll if content grows
                            overflowX: 'hidden',
                            '&::-webkit-scrollbar': {
                                width: '6px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: '#ccc',
                                borderRadius: '4px',
                            },
                        }}
                    >
                        <Divider />
                        <Typography sx={{ ml: displaysidebar ? 2 : 0, mt: 2, display: 'flex', fontSize: '8px', margin: '70px 0px 0px 14px' }}>
                            {displaysidebar ? "MENU" : <MoreHorizIcon sx={{ display: 'flex', color: 'darkgrey', fontSize: '20px', margin: '0px 0px 0px 0px' }} />}
                        </Typography>

                        <List>
                            {/* Top level menus */}
                            {topLevelMenus?.map((menuKey: string) => {
                                const menu = sidebarMenuMap[menuKey];
                                if (!menu) return null;

                                return (
                                    <ListItem key={menuKey} disablePadding>
                                        <ListItemButton
                                            // component={Link}
                                            // to={menu.path}
                                            onClick={() => this.handleItemClick(menu.path)}
                                            // relative="path"
                                            sx={{
                                                backgroundColor: activeItem === menu.path ? '#edf4fb' : 'transparent',
                                                borderRadius: '8px',
                                                padding: '10px 12px',
                                                margin: '4px 0px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                '&:hover': {
                                                    backgroundColor: '#edf4fb',
                                                },
                                                transition: 'all 0.3s',
                                                color: activeItem === menu.path ? '#1d4ed8' : '#333',
                                                fontWeight: activeItem === menu.path ? 'bold' : 'normal',
                                            }}
                                        >
                                            <ListItemIcon sx={{ minWidth: '32px', color: activeItem === menu.path ? '#1d4ed8' : 'inherit' }}>{menu?.icon}</ListItemIcon>
                                            {displaysidebar && <ListItemText primary={menu.label} primaryTypographyProps={{
                                                sx: {
                                                    fontSize: '11px',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                }
                                            }} />}
                                        </ListItemButton>
                                    </ListItem>
                                );
                            })}

                            {/* MIS Report submenu */}
                            {misReportMenus?.length > 0 && (
                                <>
                                    <ListItemButton
                                        onClick={this.toggleReport}
                                        selected={misReportMenus?.some((m: any) => activeItem === sidebarMenuMap[m]?.path)}
                                        sx={{
                                            backgroundColor: misReportMenus?.some((m: any) => activeItem === sidebarMenuMap[m]?.path) ? '#edf4fb' : 'transparent',
                                            borderRadius: '8px',
                                            padding: '10px 12px',
                                            margin: '4px 0px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            '&:hover': {
                                                backgroundColor: '#edf4fb',
                                            },
                                            transition: 'all 0.3s',
                                            color: '#333',
                                            fontWeight: 'normal',
                                        }}
                                    >
                                        <ListItemIcon >
                                            <ReportIcon />
                                        </ListItemIcon>
                                        {displaysidebar && <ListItemText primary="MIS Report" primaryTypographyProps={{ sx: { fontSize: '11px' } }} />}
                                        {displaysidebar && (reportOpen ? <ExpandLess /> : <ExpandMore />)}
                                    </ListItemButton>

                                    <Collapse in={reportOpen && displaysidebar} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding sx={{
                                            marginLeft: 2,
                                            maxHeight: '200px',
                                            overflowY: 'auto',
                                            overflowX: 'hidden',
                                            pr: 1,
                                            scrollbarWidth: "none",
                                            msOverflowStyle: "none",
                                            "&::-webkit-scrollbar": {
                                                display: "none",
                                            },
                                        }}>
                                            {misReportMenus?.map((subMenuKey: string) => {
                                                const subMenu = sidebarMenuMap[subMenuKey];
                                                return (
                                                    <ListItemButton
                                                        key={subMenuKey}
                                                        // component={Link}
                                                        // to={subMenu.path}
                                                        onClick={() => this.handleItemClick(subMenu.path)}
                                                        // relative="path"
                                                        sx={{
                                                            backgroundColor: activeItem === subMenu.path ? '#edf4fb' : 'transparent',
                                                            borderRadius: '8px',
                                                            padding: '5px 5px',
                                                            margin: '4px 0px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            '&:hover': {
                                                                backgroundColor: '#edf4fb',
                                                            },
                                                            transition: 'all 0.3s',
                                                            color: activeItem === subMenu.path ? '#1d4ed8' : '#333',
                                                            fontWeight: activeItem === subMenu.path ? 'bold' : 'normal',
                                                        }}
                                                    >
                                                        <ListItemText primary={subMenu.label} primaryTypographyProps={{ sx: { fontSize: '11px' } }} />
                                                    </ListItemButton>
                                                );
                                            })}
                                        </List>
                                    </Collapse>
                                </>
                            )}

                            {/* Jobs submenu */}
                            {jobsMenus?.length > 0 && (
                                <>
                                    <ListItemButton
                                        onClick={this.toggleJobs}
                                        selected={jobsMenus?.some((m: any) => activeItem === sidebarMenuMap[m]?.path)}
                                        sx={{
                                            backgroundColor: jobsMenus?.some((m: any) => activeItem === sidebarMenuMap[m]?.path) ? '#edf4fb' : 'transparent',
                                            borderRadius: '8px',
                                            padding: '10px 12px',
                                            margin: '4px 0px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            '&:hover': {
                                                backgroundColor: '#edf4fb',
                                            },
                                            transition: 'all 0.3s',
                                            color: '#333',
                                            fontWeight: 'normal',
                                        }}
                                    >
                                        <ListItemIcon>
                                            <WorkOutlineIcon />
                                        </ListItemIcon>
                                        {displaysidebar && <ListItemText primary="Jobs" primaryTypographyProps={{ sx: { fontSize: '11px' } }} />}
                                        {displaysidebar && (jobsOpen ? <ExpandLess /> : <ExpandMore />)}
                                    </ListItemButton>

                                    <Collapse in={jobsOpen && displaysidebar} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding sx={{
                                            marginLeft: 2,
                                            maxHeight: '200px',
                                            overflowY: 'auto',
                                            overflowX: 'hidden',
                                            pr: 1,
                                            scrollbarWidth: "none",
                                            msOverflowStyle: "none",
                                            "&::-webkit-scrollbar": {
                                                display: "none",
                                            },
                                        }}>
                                            {jobsMenus?.map((subMenuKey: string) => {
                                                const subMenu = sidebarMenuMap[subMenuKey];
                                                return (
                                                    <ListItemButton
                                                        key={subMenuKey}
                                                        // component={Link}
                                                        // to={subMenu.path}
                                                        onClick={() => this.handleItemClick(subMenu.path)}
                                                        // relative="path"
                                                        sx={{
                                                            backgroundColor: activeItem === subMenu.path ? '#edf4fb' : 'transparent',
                                                            borderRadius: '8px',
                                                            padding: '5px 5px',
                                                            margin: '4px 0px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            '&:hover': {
                                                                backgroundColor: '#edf4fb',
                                                            },
                                                            transition: 'all 0.3s',
                                                            color: activeItem === subMenu.path ? '#1d4ed8' : '#333',
                                                            fontWeight: activeItem === subMenu.path ? 'bold' : 'normal',
                                                        }}
                                                    >
                                                        <ListItemText primary={subMenu.label} primaryTypographyProps={{ sx: { fontSize: '11px' } }} />
                                                    </ListItemButton>
                                                );
                                            })}
                                        </List>
                                    </Collapse>
                                </>
                            )}
                        </List>
                    </Box>
                </Drawer>

                <Dialog
                    open={this.state.showProfileModal}
                    onClose={this.handleProfileModalClose}
                    fullWidth
                    maxWidth="sm"
                    PaperProps={{
                        sx: {
                            borderRadius: '12px',
                            backgroundColor: '#f9fafa',
                            boxShadow: '0px 4px 20px rgba(0,0,0,0.1)'
                        }
                    }}
                >
                    <DialogTitle sx={{ fontWeight: 'bold', fontSize: '20px', paddingBottom: 0 }}>
                        Profile
                    </DialogTitle>

                    <DialogContent sx={{ paddingTop: '12px' }}>
                        {/* Profile Header */}
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: 'white',
                                padding: '16px',
                                borderRadius: '10px',
                                marginBottom: '16px',
                                boxShadow: '0px 2px 6px rgba(0,0,0,0.05)'
                            }}
                        >
                            <Avatar
                                alt="Profile"
                                src="/profile.png"
                                sx={{ width: 56, height: 56, marginRight: '16px' }}
                            >{usernameMap.charAt(0).toUpperCase()} </Avatar>
                            <Typography sx={{ fontWeight: 'bold', fontSize: '16px' }}>
                                {authUser?.userName || 'Guest'}
                            </Typography>
                        </Box>

                        {/* Personal Info Card */}
                        <Box
                            sx={{
                                backgroundColor: 'white',
                                borderRadius: '10px',
                                padding: '16px',
                                boxShadow: '0px 2px 6px rgba(0,0,0,0.05)'
                            }}
                        >
                            <Typography sx={{ fontWeight: 'bold', marginBottom: '12px', fontSize: '14px' }}>
                                Personal Information
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">Username</Typography>
                                    <Typography variant="body1">{authUser?.userName || 'Guest'}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">Email</Typography>
                                    <Typography variant="body1">{authUser?.Email || 'N/A'}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">Role</Typography>
                                    <Typography variant="body1">
                                        {UserRole[authUser?.roleId as keyof typeof UserRole] ?? 'N/A'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2" color="text.secondary">Broker ID</Typography>
                                    <Typography variant="body1">{authUser?.brokerId ?? 'N/A'}</Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    </DialogContent>

                    <DialogActions
                        sx={{
                            padding: '16px',
                            paddingTop: '12px',
                            justifyContent: 'flex-end',
                            backgroundColor: '#f9fafa'
                        }}
                    >
                        <Button
                            onClick={this.handleProfileModalClose}
                            variant="contained"
                            sx={{
                                textTransform: 'none',
                                padding: '3px 15px',
                                fontSize: '14px',
                                fontWeight: '500',
                                borderRadius: '8px',
                                backgroundColor: '#1976d2',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                }
                            }}
                        >
                            Close
                        </Button>
                    </DialogActions>

                </Dialog>


            </SidebarContainer>
        );
    }
}

export default withNavigation(Sidebarr);
